export default {
  "content": "<path d=\"M13.333 18.333L5 10l8.333-8.333 1.521 1.541L8.062 10l6.792 6.792-1.521 1.541z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};